import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-location.vue";
import mobile from "./components/mobile-location.vue";
export const info = {
    title: "地址",
    type: "inputLocation",
    icon: "h-icon-all-position-o",
    dataItemType: DataItemType.Address,
    formControllerType: FormControlType.Location,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
